import { Component, Input } from '@angular/core';
import { magicPreviewDummyData } from '../../../classes/company';

@Component({
  selector: 'aira-gauge',
  templateUrl: './aira-gauge.component.html',
  styleUrl: './aira-gauge.component.css',
  standalone: false,
})
export class AiraGaugeComponent {
  @Input() label = '';
  @Input() value: number;
  @Input() maximumValue: number;
  @Input() previewOnly: boolean = false;

  ngOnInit() {
    if (this.previewOnly) {
      this.value = magicPreviewDummyData.numberSimple;
    }
  }
}
